const envPublic = {
  NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL!,
  NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME!,
  NEXT_PUBLIC_BACKEND_API_URL: process.env.NEXT_PUBLIC_BACKEND_API_URL!,
  NEXT_PUBLIC_DEV_STRAPI_API_URL: process.env.NEXT_PUBLIC_DEV_STRAPI_API_URL!,
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!,
  NEXT_PUBLIC_AZURE_CONNECTION_STRING: process.env.NEXT_PUBLIC_AZURE_CONNECTION_STRING!,
  NEXT_PUBLIC_AZURE_IMAGES_CONTAINER: process.env.NEXT_PUBLIC_AZURE_IMAGES_CONTAINER!,
  NEXT_PUBLIC_AZURE_ACCOUNT: process.env.NEXT_PUBLIC_AZURE_ACCOUNT!,
  NEXT_PUBLIC_AZURE_BLOB_SAS_TOKEN: process.env.NEXT_PUBLIC_AZURE_BLOB_SAS_TOKEN!,
  NEXT_PUBLIC_BLOB_SAS_URL: process.env.NEXT_PUBLIC_BLOB_SAS_URL!,
  NEXT_PUBLIC_ALGOLIA_APP_ID: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!,
  NEXT_PUBLIC_ALGOLIA_APP_SECRET: process.env.NEXT_PUBLIC_ALGOLIA_APP_SECRET!,
  NEXT_PUBLIC_ALGOLIA_INDEX: process.env.NEXT_PUBLIC_ALGOLIA_INDEX!,
  NEXT_PUBLIC_STORAGE_ACCOUNT_NAME: process.env.NEXT_PUBLIC_STORAGE_ACCOUNT_NAME!,
  NEXT_PUBLIC_SKUS_BLOB_SAS_URL: process.env.NEXT_PUBLIC_SKUS_BLOB_SAS_URL!,
  NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!,
  NEXT_PUBLIC_ONESIGNAL_APP_ID: process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_BY_MOST_POPULAR:
    process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_MOST_POPULAR!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_BY_WATCHED: process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_WATCHED!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_BY_NEW: process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_NEW!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_BY_RELEASE_CALENDAR:
    process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_RELEASE_CALENDAR!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_LOWEST_ASK_ASC:
    process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_LOWEST_ASK_ASC!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_HIGHEST_BID_DESC:
    process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_HIGHEST_BID_DESC!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_ALPHABET_ASC: process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_ALPHABET_ASC!,
  NEXT_PUBLIC_ALGOLIA_REPLICA_SEARCH_BY_BARCODE:
    process.env.NEXT_PUBLIC_ALGOLIA_REPLICA_SEARCH_BY_BARCODE!,
};
export default envPublic;
